module.exports = __webpack_public_path__ + "img/intensives.934e22b7.jpg";